module.exports = __webpack_public_path__ + "static/media/robo.b1438fdf.svg";